import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button, InputAdornment, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import apiManagerUser from 'api/manager-users';
import { PersonIcon } from 'components/common/IconCommon';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { useDialog } from 'components/DialogV3';
import DialogAcceptPolicy from 'components/DialogV3/DialogAcceptPolicy';
import { PATH_ROOT, URL_POLICY } from 'constants/api';
import { AccountAlreadyExists } from 'layouts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { establishSession } from 'store/sessionSlice';
import { toastError, toastSuccess } from 'utils/helpers';
import InfoUserSSO from "./InfoUserSSO";
import { useAuthFlow } from '../AuthFlowContext';

export default function RegisterSSONoEmail(props) {
    const { email, isProvideService } = props?.SSOInfo;
    var regexPattern = /^[0-9A-Za-z_]{1,64}$/;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [first, setFirst] = useState(1);
    const { sso, clearSSOFlow } = useAuthFlow();
    const SSOAccessToken = sso.accessToken;
    const usernameConvertFromEmail = email ? (email?.split("@", 1))[0]?.replaceAll(".", "") : ''
    const [username, setUsername] = useState(usernameConvertFromEmail)
    const navigate = useNavigate();
    const [agreePolicy, setAgreePolicy] = useState(false);
    const { openDialog } = useDialog()

    const provider = props.provider

    const handleRejectSharingInfo = () => toastError(t('toast.error.title.registerError'), t('toast.error.content.sharingInfo'), { autoClose: 5000 })

    const registerSSO = (access_token, policies) => {
        return apiManagerUser.registerSSO({ access_token, username, ...props.SSOInfo }, provider, undefined, agreePolicy ? 1 : 0, policies)
    }

    useEffect(() => {
        if (!email) {
            navigate(`${PATH_ROOT}/auth/register`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleKeyDown = (e) => {
        if (e?.key === "Enter") {
            if (!regexPattern.test(username) || !agreePolicy) {

            } else {
                register();
            }
        }
    }

    const register = (policies) => {
        setFirst(0)
        registerSSO(SSOAccessToken, policies)
            .then((response) => {
                toastSuccess(t('toast.loginSuccess'));
                const { accessToken, refreshToken } = response?.data
                dispatch(establishSession({ accessToken, refreshToken }));
                clearSSOFlow();
                navigate(`${PATH_ROOT}/profile-user${isProvideService ? '?provide-service=true' : ''}`)
                setTimeout(() => {
                    toastSuccess(t('toast.loginSuccess'));
                }, 5000)
            })
            .catch((err) => {
                if (err?.response?.data?.data?.message === 'USERNAME_EXIST') {
                    toastError(t('toast.usernameExist'))
                }
            })
    }

    return (
        <>
            <Typography fontSize={28} fontWeight={600} mb={3} textAlign={'center'}>{t('dialog.regiter-sso-no-sso.title', { provider: t(`auth.${provider}`) })}</Typography>
            <div className="body-create-account">
                <InfoUserSSO username={username} SSOInfo={props.SSOInfo} />
                <div className="username-account">
                    <Typography mb={1.25}>{t('dialog.regiter-sso-no-sso.title-account')}</Typography>
                    <TextFieldVMP
                        autoFocus={true}
                        value={username}
                        onChange={(e) => { setUsername(e.target.value.trim()); setFirst(0) }}
                        error={!first && !regexPattern.test(username)}
                        helperText={!first && !regexPattern.test(username) && t('validate.usernameSSO')}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon sx={{ color: '#949595' }} />
                                </InputAdornment>
                            ),
                        }}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className="create-account-information">
                    <ErrorOutlineIcon sx={{ color: '#44494D', width: '20px', marginRight: '10px' }} />
                    <Typography pl={0.5}>{t('dialog.regiter-sso-no-sso.info', { provider: t(`auth.${provider}`) })}</Typography>
                </div>
                <div className='create-account-policy'>
                    <Checkbox
                        sx={{ marginRight: '8px' }}
                        checked={agreePolicy}
                        onChange={e => setAgreePolicy(e.target.checked)}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                e.preventDefault()
                                e.stopPropagation()
                                setAgreePolicy(!agreePolicy)
                            }
                        }}
                    />
                    <Typography display={'flex'} columnGap={0.5}>{t('dialog.regiter-sso-no-sso.i-agree')} <Typography fontWeight={600} sx={{ color: theme => theme.palette.primary.main }} onClick={() => window.open(URL_POLICY)}>{t('dialog.regiter-sso-no-sso.terms-conditions')}</Typography> {t('dialog.regiter-sso-no-sso.and')} <Typography fontWeight={600} sx={{ color: theme => theme.palette.primary.main }} onClick={() => window.open(URL_POLICY)}>{t('dialog.regiter-sso-no-sso.privacy-policy')}</Typography></Typography>
                </div>
                <div className="create-account-button">
                    <span>
                        <Button
                            size="large"
                            disabled={!regexPattern.test(username) || !agreePolicy}
                            type={'submit'}
                            variant="contained"
                            className="mb-2 w-full mt-3"
                            onClick={
                                () => openDialog(DialogAcceptPolicy, {
                                    onAction: (policies) => register(policies),
                                    onReject: handleRejectSharingInfo
                                })
                            }
                        >
                            {t('dialog.regiter-sso-no-sso.create-account')}
                        </Button>
                    </span>
                    <AccountAlreadyExists />
                </div>
            </div>
        </>
    );
}
